interface StartProps { page: number; rowsPerPage: number }
type EndProps = StartProps & { items: number };

export const start = ({ page, rowsPerPage }: StartProps): number => {
  return page * rowsPerPage + 1;
};

export const end = ({ page, rowsPerPage, items }: EndProps): number => {
  const end = (page + 1) * rowsPerPage;
  return end > items ? items : end;
};

/** The chosen page, or the last one with items when the chosen one starts past them. */
export function clampPageToItems(page: number, items: number, rowsPerPage: number): number {
  const hasItems = items !== 0;
  const startsPastItems = page * rowsPerPage >= items;
  return hasItems && startsPastItems ? Math.ceil(items / rowsPerPage) - 1 : page;
}
